<template>
  <v-data-iterator
    :items="items"
    :items-per-page="4"
    style="width: 100%"
    :footer-props="{
      itemsPerPageOptions: [4, 8, 12],
      firstIcon: 'mdi-arrow-collapse-left',
      lastIcon: 'mdi-arrow-collapse-right',
      prevIcon: 'mdi-plus',
      nextIcon: 'mdi-minus'
    }"
  >
    <template v-slot:default="props">
      <v-row>
        <v-col
          v-for="(item, i) in props.items"
          :key="i"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card class="mt-3">
            <v-row class="mx-0">
              <v-col
                cols="6"
                class="py-0"
              >
                <v-avatar
                  color="indigo"
                  class="mt-2"
                  size="24"
                >
                  <span class="white--text text-h5">{{ parseFloat(i)+parseFloat(1) }}</span>
                </v-avatar>
              </v-col>
              <v-col
                class="d-flex flex-row-reverse py-0"
                cols="6"
              >
                <v-menu
                  offset-y
                >
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      icon
                      v-on="on"
                    >
                      <v-icon
                        medium
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      link
                      @click="$emit('edit', item, i)"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-clipboard-edit</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('edit')" />
                    </v-list-item>
                    <v-list-item
                      link
                      @click="$emit('remove', i)"
                    >
                      <v-list-item-icon>
                        <v-icon color="pink">
                          mdi-trash-can-outline
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('remove')" />
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <v-list
              nav
              dense
            >
              <v-list-item>
                <v-list-item-content>{{ $t('documentType') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.documentType.name }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('fromLanguage') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.fromLanguage.name }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('toLanguage') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.toLanguage.name }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('customerTitle') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.customerTitle }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('customerContent') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.customertContent }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('documentCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.documentCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('baseCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.baseCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('addDocumentCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.addDocumentCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('percentDocumentCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.percentDocumentCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('countSpecialTranslat') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.countSpecialTranslat }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('countSpecialTranslatAdditional') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.countSpecialTranslatAdditional }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('baseTranslate') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.basePriceTotal) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('addDocument') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.addDocumentPriceTotal) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('specialTranslat') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.specialTranslatTotal) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('specialTranslatAdditional') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.specialTranslatAddPriceTotal) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('judicialApprovalCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.judicialApprovalCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('foreignApprovalCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.foreignApprovalCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('stampTranslatorCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.stampTranslatorCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('officeServicesCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.officeServicesCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('verificationServicesCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.verificationServicesCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('equalOriginalCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.equalOriginalCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('embassyCount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ item.embassyCount }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('judicialApprovalPrice') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.judicialApprovalPrice*item.judicialApprovalCount) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('foreignApprovalPrice') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.foreignApprovalPrice*item.foreignApprovalCount) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('stampTranslatorPrice') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.stampTranslatorPrice*item.stampTranslatorCount) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('officeServicesPrice') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.officeServicesPrice*item.officeServicesCount) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('verificationServicesPrice') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.verificationServicesPrice*item.verificationServicesCount) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('equalOriginalPrice') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.equalOriginalPrice*item.equalOriginalCount) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('embassyPrice') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.embassyPrice*item.embassyCount) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('urgentAmount') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.urgentAmount) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #ffb2ac">
                <v-list-item-content>{{ $t('discountService') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.discountService) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #ffb2ac">
                <v-list-item-content>{{ $t('discountTranslate') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.discountTranslate) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #abe09b">
                <v-list-item-content>{{ $t('totalCost') }}:</v-list-item-content>
                <v-list-item-content class="align-end">
                  {{ $numberFormat(item.totalCost) }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-data-iterator>
</template>

<script>
  export default {
    name: 'TranslationOrderItem',
    components: {
    },
    props: ['items'],
    data: () => ({
      order: [],
    }),
    watch: {
      items () {
      },
    },
    beforeMount () {
    },
    mounted () {
    },
    methods: {
    },
  }
</script>

<style scoped>
.v-list-item {
  min-height: 24px !important;
}
.v-list-item__content {
  padding: 4px 0px !important;
}
</style>
